const normalizeBaseUrl = (url) => {
  return (url || "").trim().replace(/\/+$/, "");
};

export const BaseUrl = normalizeBaseUrl(
  process.env.REACT_APP_API_URL || "http://localhost:6060"
);

export const FacilityBaseUrl = normalizeBaseUrl(
  process.env.REACT_APP_FACILITY_API_URL || "http://localhost:6061"
);

export const CarrersBaseUrl = normalizeBaseUrl(
  process.env.REACT_APP_CAREERS_BASE_URL ||
    "https://avijocareer-production.up.railway.app"
);